export const systemAccountDataSponsorOptions = [
    { label: 'Chọn tài khoản', value: '' },
    { label: 'SANN', value: 'data_sponsor' },
    { label: 'Zynet', value: 'datasponsor_zynet' },
]

export const systemAccountAffapiOptions = [
    { label: 'Chọn tài khoản', value: '' },
    { label: 'SANN', value: 'aff_sann' },
    { label: 'Zynet', value: 'aff_zynet' },
]

export const systemAccountVDSOptions = [
    { label: 'Chọn tài khoản', value: '' },
    { label: 'VDS Data Sponsor', value: 'vds-data-sponsor' },
]

export const systemProvidorOptions = [
    { label: 'Chọn nhà cung cấp', value: '' },
    { label: 'Affapi', value: 'ds_postpaid' },
    { label: 'DataSponsor', value: 'data_sponsor' },
]

export const systemProviderDataSponsorOptions = [
    { label: 'Chọn nhà cung cấp', value: '' },
    { label: 'Viettel TT', value: 'data_sponsor' },
    { label: 'VDS', value: 'vds' },
]

export const systemProviderDsPostpaidOptions = [
    { label: 'Chọn nhà cung cấp', value: '' },
    { label: 'Viettel TT', value: 'ds_postpaid' },
    { label: 'VDS', value: 'vds' },
]

export const systemMethodSelectProviderOptions = [
    { label: 'Chọn phương thức', value: '' },
    { label: 'Static', value: 'static' },
    { label: 'Weight Random', value: 'weightrandom' },
    { label: 'Load Balance', value: 'loadbalance' },
]

export const TDM_SOURCE = 'TDMSource'

export const providerTDMsourceOptions = [
    { label: 'TDM_ZYNET', value: 'TDM_ZYNET' },
]

export const partnerPackageStatusOptions = [
    { label: 'Hoạt động', value: 'Active' },
    { label: 'Ngừng hoạt động', value: 'Disable' },
]

export const partnerPackageDataSponsorSourceOptions = [
    { label: 'Đại trà', value: 'DataSponsor' },
    { label: 'Upgrade', value: 'Affapi' },
    { label: 'Thủ đô', value: 'TDMSource' },
    { label: 'TV360', value: 'TV360Viettel' },
    { label: 'TKG', value: 'TKG' },
]

export const providerSourceOptions = [
    {label: 'DataSponsor', value: 'data_sponsor'},
    {label: 'Ds PostPaid', value: 'ds_postpaid'},
    {label: 'Vds', value: 'vds'},
]

export const serviceCodeOptions = [
    { label: 'Nhà mạng Viettel', value: 'DATAVTKPP' },
    { label: 'Nhà mạng Vinaphone', value: 'DATAVN' },
    { label: 'Nhà mạng Mobiphone', value: 'DATAMB' },
]

export const groupCodeOptions = [
    { label: 'Sponsor trong nước', value: '1' },
    { label: 'Sponsor quốc tế', value: '2' },
    { label: 'Upgrade', value: '3' },
    { label: 'Sponsor cho thuê bao trả trước', value: '4' },
]

export const packageTypeOptions = [
    { label: '3G', value: '3G' },
    { label: '4G', value: '4G' },
    { label: '5G', value: '5G' },
    { label: 'ADDON', value: 'ADDON' },
]

export const providerDisplayOptions = [
    {label: 'Viettel TT', value: 'viettel_tt'}, // viettel_tt is data_sponsor or ds_postpaid
    {label: 'VDS', value: 'vds'},
]

export const partnerPackageDataCodeSourceOptions = [
    { label: 'DataSponsor', value: 'DataSponsor' },
    { label: 'Affapi', value: 'Affapi' },
    { label: 'TopUp', value: 'TopUp' },
    { label: 'PinCode', value: 'PinCode' },
]

export const reportType = [
    { label: 'Doanh thu', value: 'revenue' },
    { label: 'DataSponsor', value: 'data_sponsor' },
    { label: 'Datacode', value: 'data_code' },
]

export const companyAccountDatasponsor = 'datasponsor'
export const companyAccountAffapi = 'affapi'
export const companyAccountVds = 'vds'
export const companyAcctionOptions = [
    {
        label: 'Data sponsor',
        value: 'datasponsor',
        children: [
            {
                value: 'CONG_TY_SANN',
                title: 'CÔNG TY SANN',
            },
            {
                value: 'CONG_TY_ZYNET',
                title: 'CÔNG TY ZYNET',
            },
        ],
    },
    {
        label: 'Affapi',
        value: 'affapi',
        children: [
            {
                value: 'aff_sann',
                title: 'AFF SANN',
            },
            {
                value: 'aff_zynet',
                title: 'AFF ZYNET',
            },
        ],
    },
    {
        label: 'VDS',
        value: 'vds',
        children: [
            {
                value: 'vds-data-sponsor',
                title: 'VDS Data Sponsor',
            },
            {
                value: 'vds-ds-postpaid',
                title: 'VDS DS Postpaid',
            },
        ],
    },
]

export const maintainanceProviderOptions = [
    { label: 'Đại trà', value: 'data_sponsor' },
    { label: 'Upgrade', value: 'ds_postpaid' },
    { label: 'VDS', value: 'vds' },
]